import { isDigitalGift } from '@moonpig/web-shared-products'
import { ProductWithRecommendations } from '../../components/ProductDetails'
import {
  giftAndFlowers,
  giftAndFlowersOutOfStock,
  digitalGifts,
} from '../../components/ProductDetailsModular/layouts'

export const getModularLayout = (product: ProductWithRecommendations) => {
  const { variants } = product

  const inStock = variants.some(variant => variant.inStock)

  if (isDigitalGift(product.category.department)) {
    return digitalGifts(inStock)
  }

  return inStock ? giftAndFlowers : giftAndFlowersOutOfStock
}
